document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".absorbia-site .menu-toggle").forEach(function (toggle) {
    const header = toggle.closest(".site-header");
    const nav = header ? header.querySelector(".main-nav") : document.querySelector(".absorbia-site .main-nav");
    if (!nav) return;

    toggle.addEventListener("click", function () {
      const isOpen = nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", String(isOpen));
    });

    nav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        if (window.innerWidth <= 1100) {
          nav.classList.remove("open");
          toggle.setAttribute("aria-expanded", "false");
        }
      });
    });
  });

  document.querySelectorAll("[data-absorbia-qty]").forEach(function (wrap) {
    const input = wrap.querySelector(".qty-input");
    const minus = wrap.querySelector("[data-qty-minus]");
    const plus = wrap.querySelector("[data-qty-plus]");
    if (!input) return;

    function setQty(value) {
      const next = Math.max(1, parseInt(value, 10) || 1);
      input.value = String(next);
    }

    if (minus) {
      minus.addEventListener("click", function () {
        setQty((parseInt(input.value, 10) || 1) - 1);
      });
    }

    if (plus) {
      plus.addEventListener("click", function () {
        setQty((parseInt(input.value, 10) || 1) + 1);
      });
    }

    input.addEventListener("change", function () {
      setQty(input.value);
    });
  });

  document.querySelectorAll("[data-absorbia-wishlist]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      btn.classList.toggle("is-active");
      btn.textContent = btn.classList.contains("is-active") ? "♥" : "♡";
    });
  });

  document.querySelectorAll("[data-absorbia-feedback]").forEach(function (box) {
    const thanks = box.querySelector(".feedback-thanks");
    box.querySelectorAll("[data-feedback]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        box.querySelectorAll("[data-feedback]").forEach(function (b) {
          b.disabled = true;
        });
        if (thanks) thanks.hidden = false;
      });
    });
  });

  document.querySelectorAll("[data-absorbia-gallery]").forEach(function (gallery) {
    const main = gallery.querySelector("[data-absorbia-main-image]");
    if (!main) return;

    gallery.querySelectorAll("[data-absorbia-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        const full = thumb.getAttribute("data-full-src");
        const img = thumb.querySelector("img");
        const src = full || (img && (img.currentSrc || img.src));
        if (!src) return;
        main.src = src;
        main.removeAttribute("srcset");
        gallery.querySelectorAll("[data-absorbia-thumb]").forEach(function (t) {
          t.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });
  });

  document.querySelectorAll("[data-absorbia-product-form]").forEach(function (form) {
    const variantInput = form.querySelector("[data-absorbia-variant-id]");
    const jsonEl = form.querySelector("[data-absorbia-variant-json]");
    const optionEls = form.querySelectorAll("[data-absorbia-option]");
    const addBtn = form.querySelector("[data-absorbia-add]");
    const buyBtn = form.querySelector(".btn-buy");
    const stockEl = form.closest(".product-info")
      ? form.closest(".product-info").querySelector(".stock")
      : null;
    const priceEl = form.closest(".product-info")
      ? form.closest(".product-info").querySelector("[data-absorbia-price]")
      : null;

    if (!variantInput || !jsonEl || !optionEls.length) return;

    let variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    function selectedOptions() {
      return Array.prototype.map.call(optionEls, function (el) {
        return el.value;
      });
    }

    function findVariant() {
      const selected = selectedOptions();
      return variants.find(function (v) {
        return selected.every(function (val, i) {
          return v["option" + (i + 1)] === val;
        });
      });
    }

    function formatMoney(cents) {
      var currency =
        (window.Shopify && Shopify.currency && Shopify.currency.active) || "INR";
      try {
        return (cents / 100).toLocaleString("en-IN", {
          style: "currency",
          currency: currency,
        });
      } catch (e) {
        return "₹" + (cents / 100).toFixed(2);
      }
    }

    function sync() {
      const variant = findVariant();
      if (!variant) return;
      variantInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (buyBtn) buyBtn.disabled = !variant.available;
      if (stockEl) {
        stockEl.textContent = variant.available ? "In stock" : "Sold out";
        stockEl.classList.toggle("in-stock", variant.available);
        stockEl.classList.toggle("out-of-stock", !variant.available);
      }
      if (priceEl) {
        priceEl.innerHTML = formatMoney(variant.price);
      }
      if (variant.id && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url.toString());
      }
    }

    optionEls.forEach(function (el) {
      el.addEventListener("change", sync);
    });
  });

  document.querySelectorAll("[data-absorbia-why-faq]").forEach(function (page) {
    page.querySelectorAll(".aqp-faq__toggle").forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest(".aqp-faq__item");
        if (!item) return;
        var isOpen = item.classList.contains("is-open");

        page.querySelectorAll(".aqp-faq__item").forEach(function (row) {
          row.classList.remove("is-open");
          var rowButton = row.querySelector(".aqp-faq__toggle");
          if (rowButton) rowButton.setAttribute("aria-expanded", "false");
        });

        if (!isOpen) {
          item.classList.add("is-open");
          button.setAttribute("aria-expanded", "true");
        }
      });
    });
  });

  document.querySelectorAll("[data-absorbia-survey-popup]").forEach(function (popup) {
    var storageKey = popup.getAttribute("data-storage-key") || "absorbia_survey_popup_dismissed";
    var delay = parseInt(popup.getAttribute("data-delay"), 10);
    if (isNaN(delay) || delay < 0) delay = 800;

    function hidePopup() {
      popup.classList.add("is-hidden");
      try {
        sessionStorage.setItem(storageKey, "1");
      } catch (e) {}
      document.documentElement.classList.remove("absorbia-survey-popup-open");
    }

    function showPopup() {
      popup.classList.remove("is-hidden");
      document.documentElement.classList.add("absorbia-survey-popup-open");
    }

    try {
      if (sessionStorage.getItem(storageKey) === "1") return;
    } catch (e) {}

    window.setTimeout(showPopup, delay);

    popup.querySelectorAll("[data-absorbia-survey-close]").forEach(function (btn) {
      btn.addEventListener("click", hidePopup);
    });

    popup.addEventListener("click", function (event) {
      if (event.target === popup) hidePopup();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !popup.classList.contains("is-hidden")) {
        hidePopup();
      }
    });
  });

  document.querySelectorAll("[data-absorbia-support-form]").forEach(function (form) {
    stripAbsorbiaRoutingNote(form);
    var natureField = form.querySelector("[data-absorbia-nature-field]");
    var fileInput = form.querySelector("[data-absorbia-support-file]");
    var fileName = form.querySelector("[data-absorbia-support-file-name]");
    var message = form.querySelector("[data-absorbia-support-body]") || form.querySelector('textarea[name="contact[body]"]');
    var categorySelect = form.querySelector("[data-absorbia-support-category]");
    var productSelect = form.querySelector("[data-absorbia-support-product]");
    var mapEl = form.querySelector("[data-absorbia-product-map]");
    var productMap = {};
    var productPlaceholder =
      (productSelect && productSelect.options[0] && productSelect.options[0].textContent) ||
      "Select product";

    try {
      if (mapEl) productMap = JSON.parse(mapEl.textContent || "{}");
    } catch (e) {
      productMap = {};
    }

    function fillProducts(category) {
      if (!productSelect) return;
      var list = (category && productMap[category]) || [];
      productSelect.innerHTML = "";

      var placeholder = document.createElement("option");
      placeholder.value = "";
      placeholder.disabled = true;
      placeholder.selected = true;
      placeholder.textContent = productPlaceholder;
      productSelect.appendChild(placeholder);

      if (!category) {
        productSelect.disabled = true;
        return;
      }

      if (!list.length) {
        var empty = document.createElement("option");
        empty.value = "";
        empty.disabled = true;
        empty.textContent = "No products in this category";
        productSelect.appendChild(empty);
        productSelect.disabled = true;
        return;
      }

      list.forEach(function (title) {
        var opt = document.createElement("option");
        opt.value = title;
        opt.textContent = title;
        productSelect.appendChild(opt);
      });
      productSelect.disabled = false;
    }

    if (categorySelect) {
      categorySelect.addEventListener("change", function () {
        fillProducts(categorySelect.value);
      });
      fillProducts(categorySelect.value || "");
    }

    if (fileInput && fileName) {
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        fileName.textContent = file ? file.name : "No File Chosen";
      });
    }

    form.addEventListener("submit", function (event) {
      try {
        sessionStorage.setItem("absorbia-support-last-tab", form.getAttribute("data-support-tab") || "");
      } catch (e) {}

      if (natureField) {
        var selected = [];
        form.querySelectorAll("[data-absorbia-nature]:checked").forEach(function (el) {
          selected.push(el.value);
        });
        natureField.value = selected.join(", ");
      }

      if (message && !message.value.trim()) {
        var source = form.querySelector('[name="contact[form_source]"]');
        message.value = ((source && source.value) || "Support") + " submitted.";
      }

      if (message && fileInput && fileInput.files && fileInput.files[0]) {
        var note = "\n\n[Attachment selected: " + fileInput.files[0].name + "]";
        if (message.value.indexOf("[Attachment selected:") === -1) {
          message.value = message.value + note;
        }
      }

      finishAbsorbiaFormSubmit(form);
    });
  });

  var tabNav = document.querySelector("[data-absorbia-support-tabs]");
  if (tabNav) {
    var tabButtons = tabNav.querySelectorAll("[data-tab]");
    var tabPanels = document.querySelectorAll("[data-tab-panel]");

    var firstTab = tabButtons[0] ? tabButtons[0].getAttribute("data-tab") : "register";
    var lastSubmittedTab = "";
    try {
      lastSubmittedTab = sessionStorage.getItem("absorbia-support-last-tab") || "";
    } catch (e) {}

    if (lastSubmittedTab) {
      document.querySelectorAll("[data-absorbia-support-form]").forEach(function (form) {
        var success = form.querySelector(".abs-support-form-success");
        if (success && form.getAttribute("data-support-tab") !== lastSubmittedTab) {
          success.remove();
        }
      });
    }

    function showSupportTab(id) {
      if (!document.querySelector('[data-tab-panel="' + id + '"]')) {
        id = firstTab;
      }
      tabButtons.forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-tab") === id);
      });
      tabPanels.forEach(function (panel) {
        var on = panel.getAttribute("data-tab-panel") === id;
        panel.hidden = !on;
        var fieldset = panel.querySelector(".abs-support-form-fields");
        if (fieldset) fieldset.disabled = !on;
      });
    }

    function supportTabFromHash() {
      var id = (window.location.hash || "").replace("#", "");
      var posted = window.location.search.indexOf("contact_posted=true") !== -1;
      if ((posted || !document.querySelector('[data-tab-panel="' + id + '"]')) && lastSubmittedTab) {
        id = lastSubmittedTab;
      } else if (!id && lastSubmittedTab) {
        id = lastSubmittedTab;
      }
      showSupportTab(id || firstTab);
      if (!posted || !lastSubmittedTab) return;
      var form = document.querySelector(
        '[data-absorbia-support-form][data-support-tab="' + lastSubmittedTab + '"]'
      );
      if (!form || form.querySelector(".abs-support-form-success")) return;
      var note = document.createElement("div");
      note.className = "abs-support-form-success";
      note.setAttribute("tabindex", "-1");
      note.textContent =
        form.getAttribute("data-success-message") ||
        "Thank you. Your support request has been submitted. Our team will get back to you soon.";
      var fields = form.querySelector(".abs-support-form-fields");
      if (fields) fields.insertBefore(note, fields.firstChild);
      else form.insertBefore(note, form.firstChild);
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        var id = btn.getAttribute("data-tab");
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, "", "#" + id);
        } else {
          window.location.hash = id;
        }
        showSupportTab(id);
      });
    });

    window.addEventListener("hashchange", supportTabFromHash);
    supportTabFromHash();
  }
});

function initAbsorbiaHeroSliders(root) {
  var scope = root || document;
  var sliders = scope.querySelectorAll
    ? scope.querySelectorAll("[data-absorbia-hero-slider]")
    : [];

  sliders.forEach(function (slider) {
    if (slider.getAttribute("data-hero-ready") === "true") return;

    var slides = slider.querySelectorAll(".hero-slide");
    if (slides.length < 2) return;

    var dots = slider.querySelectorAll("[data-hero-dot]");
    var prev = slider.querySelector("[data-hero-prev]");
    var next = slider.querySelector("[data-hero-next]");
    var autoplay = slider.getAttribute("data-autoplay") === "true";
    var interval = parseInt(slider.getAttribute("data-interval"), 10);
    if (isNaN(interval) || interval < 3) interval = 6;

    var reduceMotion =
      window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var index = 0;
    var timer = null;
    var startX = 0;

    function goTo(nextIndex, pause) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle("is-active", on);
        slide.setAttribute("aria-hidden", on ? "false" : "true");
      });
      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle("is-active", on);
        if (on) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
      if (pause) stop();
      else restart();
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function restart() {
      stop();
      if (!autoplay || reduceMotion) return;
      timer = window.setInterval(function () {
        goTo(index + 1, false);
      }, interval * 1000);
    }

    if (prev) {
      prev.addEventListener("click", function () {
        goTo(index - 1, true);
        restart();
      });
    }
    if (next) {
      next.addEventListener("click", function () {
        goTo(index + 1, true);
        restart();
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        var i = parseInt(dot.getAttribute("data-hero-dot"), 10);
        if (!isNaN(i)) goTo(i, true);
        restart();
      });
    });

    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", restart);
    slider.addEventListener("focusin", stop);
    slider.addEventListener("focusout", restart);

    slider.addEventListener("touchstart", function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      startX = event.changedTouches[0].clientX;
    }, { passive: true });

    slider.addEventListener("touchend", function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      var dx = event.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      if (dx > 0) goTo(index - 1, true);
      else goTo(index + 1, true);
      restart();
    }, { passive: true });

    slider._absorbiaHero = { goTo: goTo, stop: stop };
    slider.setAttribute("data-hero-ready", "true");
    goTo(0, false);
  });
}

document.addEventListener("shopify:section:load", function (event) {
  initAbsorbiaHeroSliders(event.target);
  initAbsorbiaCareerForm(event.target);
  initAbsorbiaAboutVideos(event.target);
});

document.addEventListener("shopify:block:select", function (event) {
  var slide = event.target.closest(".hero-slide");
  var slider = event.target.closest("[data-absorbia-hero-slider]");
  if (!slide || !slider || !slider._absorbiaHero) return;
  var slides = slider.querySelectorAll(".hero-slide");
  var index = Array.prototype.indexOf.call(slides, slide);
  if (index >= 0) slider._absorbiaHero.goTo(index, true);
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    initAbsorbiaHeroSliders(document);
    initAbsorbiaCareerForm(document);
    initAbsorbiaAboutVideos(document);
  });
} else {
  initAbsorbiaHeroSliders(document);
  initAbsorbiaCareerForm(document);
  initAbsorbiaAboutVideos(document);
}

function initAbsorbiaAboutVideos(root) {
  var scope = root || document;
  var videos = scope.querySelectorAll
    ? scope.querySelectorAll(".products-details-about-image video, video.about-video, video.about-visual-media")
    : [];
  if (!videos.length) return;

  videos.forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute("muted", "");
    video.playsInline = true;
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.autoplay = true;
    video.setAttribute("autoplay", "");
    video.loop = true;

    function tryPlay() {
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {});
      }
    }

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener("canplay", tryPlay, { once: true });
      video.addEventListener("loadeddata", tryPlay, { once: true });
    }
  });
}

function absorbiaNotifyList(form) {
  var notifyEl =
    form.querySelector("[data-absorbia-notify-emails]") ||
    form.querySelector('[name="contact[Notify]"]');
  var raw = notifyEl && notifyEl.value ? notifyEl.value : "";
  var seen = {};
  var list = [];
  raw.split(/[;,]/).forEach(function (part) {
    var email = part.trim().toLowerCase();
    if (!email || seen[email]) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
    seen[email] = true;
    list.push(email);
  });
  return list;
}

function absorbiaDeliverToNotify(form) {
  var recipients = absorbiaNotifyList(form);
  if (!recipients.length) return Promise.resolve();

  var payload = {
    _template: "table",
    _captcha: "false",
    _subject: "Absorbia form",
  };
  var subjectEl =
    form.querySelector("[data-absorbia-email-subject]") ||
    form.querySelector('[name="contact[subject]"]');
  if (subjectEl && subjectEl.value.trim()) payload._subject = subjectEl.value.trim();

  var replyEl = form.querySelector('[name="contact[email]"]');
  if (replyEl && replyEl.value.trim()) payload._replyto = replyEl.value.trim();

  form.querySelectorAll("input, textarea, select").forEach(function (el) {
    if (!el.name || el.disabled || el.type === "file" || el.type === "submit" || el.type === "button") return;
    if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;
    var label = el.name.replace(/^contact\[/, "").replace(/\]$/, "");
    if (!label || label === "Notify" || label === "subject") return;
    var value = (el.value || "").trim();
    if (!value) return;
    payload[label] = payload[label] ? payload[label] + ", " + value : value;
  });

  var body = JSON.stringify(payload);
  recipients.forEach(function (email) {
    fetch("https://formsubmit.co/ajax/" + email, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: body,
    }).catch(function () {});
  });
}

function finishAbsorbiaFormSubmit(form) {
  absorbiaDeliverToNotify(form);
}

function stripAbsorbiaRoutingNote(form) {
  if (!form) return;
  var message =
    form.querySelector("[data-absorbia-support-body]") ||
    form.querySelector("[data-absorbia-career-message]") ||
    form.querySelector('textarea[name="contact[body]"]');
  if (!message || !message.value) return;
  message.value = message.value
    .replace(/\[Absorbia routing\]\s*\nSubject:[^\n]*\nNotify:[^\n]*\n*/g, "")
    .replace(/^\n+/, "");
}

function initAbsorbiaCareerForm(root) {
  var scope = root || document;
  var forms = scope.querySelectorAll(".absorbia-careers-form");
  if (!forms.length) return;

  forms.forEach(function (form) {
    stripAbsorbiaRoutingNote(form);
    if (
      window.location.search.indexOf("contact_posted=true") !== -1 &&
      !form.querySelector(".absorbia-form-status")
    ) {
      var note = document.createElement("p");
      note.className = "absorbia-form-status is-visible";
      note.setAttribute("tabindex", "-1");
      note.textContent =
        form.getAttribute("data-success-message") || "Thanks. Your application has been sent.";
      form.insertBefore(note, form.firstChild);
    }
    var fileInput = form.querySelector("[data-absorbia-career-file-input]");
    var fileName = form.querySelector("[data-absorbia-career-file-name]");
    var message = form.querySelector("[data-absorbia-career-message]");
    var roleSelect = form.querySelector("[data-absorbia-career-role]");

    var cvLink = form.querySelector("[name='contact[CV link]']");

    if (fileInput && fileName) {
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        fileName.textContent = file ? file.name : "No file chosen";
        if (cvLink) cvLink.setCustomValidity("");
      });
    }

    if (cvLink) {
      cvLink.addEventListener("input", function () {
        cvLink.setCustomValidity("");
      });
    }

    form.addEventListener("submit", function (event) {
      var cvLink = form.querySelector("[name='contact[CV link]']");
      var hasFile = fileInput && fileInput.files && fileInput.files[0];
      var hasLink = cvLink && cvLink.value.trim();

      if (!hasFile && !hasLink) {
        event.preventDefault();
        if (cvLink) {
          cvLink.setCustomValidity("Add a CV file or paste a resume link.");
          cvLink.reportValidity();
        }
        return;
      }

      if (cvLink) cvLink.setCustomValidity("");

      var subjectEl = form.querySelector("[data-absorbia-email-subject]");
      if (subjectEl) {
        var base = subjectEl.getAttribute("data-subject-base") || "Absorbia Careers — Job application";
        var role = roleSelect && roleSelect.value ? roleSelect.value.trim() : "";
        subjectEl.value = role ? base + ": " + role : base;
      }

      if (message && hasFile) {
        var note = "\n\n[CV file selected: " + fileInput.files[0].name + "]";
        if (message.value.indexOf("[CV file selected:") === -1) {
          message.value = message.value + note;
        }
      }

      finishAbsorbiaFormSubmit(form);
    });

    if (roleSelect) {
      document.querySelectorAll("[data-absorbia-apply-role]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var title = btn.getAttribute("data-absorbia-apply-role") || "";
          if (!title) return;
          roleSelect.value = title;
        });
      });
    }
  });
}
